var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("profile.title")))]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c(
          "v-tabs",
          { attrs: { centered: "", "icons-and-text": "" } },
          [
            _c(
              "v-tab",
              { key: "general" },
              [
                _vm._v(" " + _vm._s(_vm.$t("profile.personalData")) + " "),
                _c("v-icon", [_vm._v("account_box")])
              ],
              1
            ),
            _c(
              "v-tab",
              { key: "permissions" },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("profile.rolesAndPermissions")) + " "
                ),
                _c("v-icon", [_vm._v("pan_tool")])
              ],
              1
            ),
            _c(
              "v-tab-item",
              { key: "general" },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            attrs: { "lazy-validation": "" },
                            model: {
                              value: _vm.formValid,
                              callback: function($$v) {
                                _vm.formValid = $$v
                              },
                              expression: "formValid"
                            }
                          },
                          [
                            _c(
                              "v-radio-group",
                              {
                                attrs: {
                                  mandatory: false,
                                  row: "",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.users.sex,
                                  callback: function($$v) {
                                    _vm.$set(_vm.users, "sex", $$v)
                                  },
                                  expression: "users.sex"
                                }
                              },
                              [
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.mr"),
                                    value: 1
                                  }
                                }),
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.ms"),
                                    value: 2
                                  }
                                }),
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.notSet"),
                                    value: 0
                                  }
                                })
                              ],
                              1
                            ),
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("profile.fields.name.name") + "*",
                                disabled: "",
                                rules: _vm.users.nameRules
                              },
                              model: {
                                value: _vm.users.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "name", $$v)
                                },
                                expression: "users.name"
                              }
                            }),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.middleName.name"
                                    ),
                                    placeholder: _vm.$t("global.optional")
                                  },
                                  model: {
                                    value: _vm.users.middle_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "middle_name", $$v)
                                    },
                                    expression: "users.middle_name"
                                  }
                                })
                              : _vm._e(),
                            _c("v-text-field", {
                              attrs: {
                                label:
                                  _vm.$t("profile.fields.surname.name") + "*",
                                disabled: "",
                                rules: _vm.users.surnameRules
                              },
                              model: {
                                value: _vm.users.surname,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "surname", $$v)
                                },
                                expression: "users.surname"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label:
                                  _vm.$t("profile.fields.login.name") + "*",
                                disabled: "",
                                rules: _vm.users.loginRules
                              },
                              model: {
                                value: _vm.users.login,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "login", $$v)
                                },
                                expression: "users.login"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label:
                                  _vm.$t("profile.fields.email.name") + "*",
                                disabled: "",
                                rules: _vm.users.emailRules
                              },
                              model: {
                                value: _vm.users.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "email", $$v)
                                },
                                expression: "users.email"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t(
                                  "profile.fields.integrationIdentifier.name"
                                ),
                                disabled: ""
                              },
                              model: {
                                value: _vm.users.integration_identifier,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.users,
                                    "integration_identifier",
                                    $$v
                                  )
                                },
                                expression: "users.integration_identifier"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t(
                                  "profile.fields.superiorUser.name"
                                ),
                                disabled: ""
                              },
                              model: {
                                value: _vm.users.superior_user_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "superior_user_name", $$v)
                                },
                                expression: "users.superior_user_name"
                              }
                            }),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "profile.fields.organizationStructure.name"
                                    ),
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.users.organization_structure_name,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "organization_structure_name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "users.organization_structure_name"
                                  }
                                })
                              : _vm._e(),
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("profile.fields.password.name"),
                                password: "",
                                type: "password",
                                rules: !_vm.users.password
                                  ? []
                                  : _vm.users.passwordRules,
                                placeholder:
                                  _vm.users.id != null
                                    ? _vm.$t("profile.fields.password.noChange")
                                    : ""
                              },
                              model: {
                                value: _vm.users.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "password", $$v)
                                },
                                expression: "users.password"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t(
                                  "profile.fields.repeatPassword.name"
                                ),
                                type: "password",
                                password: "",
                                rules: _vm.users.repeatPasswordRules,
                                placeholder:
                                  _vm.users.id != null
                                    ? _vm.$t(
                                        "profile.fields.repeatPassword.noChange"
                                      )
                                    : ""
                              },
                              model: {
                                value: _vm.users.repeatPassword,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "repeatPassword", $$v)
                                },
                                expression: "users.repeatPassword"
                              }
                            }),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("v-autocomplete", {
                                  attrs: {
                                    label: _vm.$t(
                                      "profile.fields.privateVehicle.name"
                                    ),
                                    items: _vm.availablePrivateVehicles
                                  },
                                  model: {
                                    value: _vm.users.vehicle_private_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "vehicle_private_id",
                                        $$v
                                      )
                                    },
                                    expression: "users.vehicle_private_id"
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("v-autocomplete", {
                                  attrs: {
                                    label: _vm.$t(
                                      "profile.fields.defaultVehicle.name"
                                    ),
                                    items: _vm.availableDefaultVehicles
                                  },
                                  model: {
                                    value: _vm.users.vehicle_default_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "vehicle_default_id",
                                        $$v
                                      )
                                    },
                                    expression: "users.vehicle_default_id"
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "profile.fields.bankName.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.bank_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "bank_name", $$v)
                                    },
                                    expression: "users.bank_name"
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "profile.fields.bankAccount.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.bank_account_number,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "bank_account_number",
                                        $$v
                                      )
                                    },
                                    expression: "users.bank_account_number"
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("location-ajax-select", {
                                  attrs: {
                                    "select-model": _vm.users.home_address_id,
                                    placeholder: _vm.users.home_address_name,
                                    label: _vm.$t("global.homeLocation")
                                  },
                                  on: {
                                    "update:selectModel": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "home_address_id",
                                        $event
                                      )
                                    },
                                    "update:select-model": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "home_address_id",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("location-ajax-select", {
                                  attrs: {
                                    "select-model": _vm.users.work_address_id,
                                    disabled: "",
                                    placeholder: _vm.users.work_address_name,
                                    label: _vm.$t("global.workLocation")
                                  },
                                  on: {
                                    "update:selectModel": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "work_address_id",
                                        $event
                                      )
                                    },
                                    "update:select-model": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "work_address_id",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "profile.fields.delegationRateGroup.name"
                                    ),
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.users.group_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "group_name", $$v)
                                    },
                                    expression: "users.group_name"
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_travel_service_enabled === 2 ||
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? _c("v-text-field", {
                                  staticClass: "user-mobile-number",
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.phone.name"
                                    ),
                                    placeholder: "+48 111-222-333",
                                    rules: _vm.users.phoneNumberRules,
                                    mask: "+## ###-###-###",
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.users.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "phone", $$v)
                                    },
                                    expression: "users.phone"
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_travel_service_enabled === 2
                              ? _c("date-picker", {
                                  attrs: {
                                    model: _vm.users.birth_date,
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.birthDate.name"
                                    )
                                  },
                                  on: {
                                    "update:model": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "birth_date",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_travel_service_enabled === 2
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.documentNumber.name"
                                    ),
                                    placeholder: "ABC 123456"
                                  },
                                  model: {
                                    value: _vm.users.document_number,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "document_number",
                                        $$v
                                      )
                                    },
                                    expression: "users.document_number"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"] &&
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_travel_service_enabled === 2
                              ? _c("date-picker", {
                                  attrs: {
                                    model: _vm.users.document_expire,
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.documentExpire.name"
                                    ),
                                    placeholder: "2020-01-01",
                                    clearable: true
                                  },
                                  on: {
                                    "update:model": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "document_expire",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"] &&
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_travel_service_enabled === 2
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.documentIssuePlace.name"
                                    ),
                                    placeholder: "Warszawa"
                                  },
                                  model: {
                                    value: _vm.users.document_issue_place,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "document_issue_place",
                                        $$v
                                      )
                                    },
                                    expression: "users.document_issue_place"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"] &&
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_travel_service_enabled === 2
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.nationality.name"
                                    ),
                                    placeholder: _vm.$t(
                                      "settings.users.basicData.fields.nationality.placeholder"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.nationality,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "nationality", $$v)
                                    },
                                    expression: "users.nationality"
                                  }
                                })
                              : _vm._e(),
                            _vm.$store.getters.hasPermission("travelOrder") &&
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_travel_service_enabled === 2
                              ? _c("v-checkbox", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.isNotifyNewTravelServiceResponse.name"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.users
                                        .is_notify_new_travel_service_response,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "is_notify_new_travel_service_response",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "users.is_notify_new_travel_service_response"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-tab-item",
              { key: "permissions" },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-text",
                      [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.$t("profile.hasPermissions")))
                        ]),
                        _c(
                          "v-data-table",
                          {
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.hasAuthItems,
                              "hide-default-footer": "",
                              "footer-props": {
                                "items-per-page-options": [
                                  {
                                    text:
                                      "$vuetify.dataIterator.rowsPerPageAll",
                                    value: -1
                                  }
                                ]
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function(props) {
                                  return [
                                    _c("tr", [
                                      _c("td", { staticClass: "text-left" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.item.type == 2
                                                ? _vm.$t("global.permission")
                                                : _vm.$t("global.role")
                                            ) +
                                            " "
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-left" }, [
                                        _vm._v(
                                          _vm._s(props.item.translated_name)
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-left" }, [
                                        _vm._v(_vm._s(props.item.description))
                                      ])
                                    ])
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _c(
                              "template",
                              { slot: "no-data" },
                              [
                                _c(
                                  "v-alert",
                                  {
                                    attrs: { color: "error", icon: "warning" }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("profile.noPermission")) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "blue darken-1",
                      text: "",
                      disabled: !_vm.formValid
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.save")))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }